
import { getQueryVariable } from '@/util/const'
import { isApp, callApp, isWx, system } from '@/util/const'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import openIcon from 'static/img/new_open_jt@2x.png'

const lang = getQueryVariable('lang') || window.localStorage.getItem('lang')
const wxGuide = {
en: {
title: 'Intelligent City·Smart Life',
open: 'Open',
ios: 'Please click “…”button,  Choose “Open in Safari"',
android: 'Please click “…”button,  Choose “Open with Browser"'
},
sc: {
title: '连接·生活',
open: '打开',
ios: '请点击右上角的"..."按钮，选择"在Safari中打开”',
android: '请点击右上角的"..."按钮，选择”在浏览器中打开”'
},
tc: {
title: '連接·生活',
open: '打開',
ios: '請點擊右上角的“…”按鈕，選擇“在Safari中開啟”',
android: '請點擊右上角的“…”按鈕，選擇“在瀏覽器中開啟”'
}
}
export default {
directives: {
TransferDom
},
props: {
url: {
type: String,
default: location.href
}
},
data () {
return {
type: 'component',
showWxGuide: false,
platform: system(),
openIcon,
wxGuide,
lang
}
},
methods: {

openApp (type) {
this.type = type
if (isWx()) {
return this.showWxGuide = true
}
callApp(this.url)
},
hideWxGuide () {
this.showWxGuide = false
},

isApp
}
}



// WEBPACK FOOTER //
// ./src/component/uiOpen/uiOpen.vue